module.exports = __webpack_public_path__ + "img/info-circle.532b2684.svg";